import { render, staticRenderFns } from "./create--code.vue?vue&type=template&id=ad0b0e72&scoped=true&"
import script from "./create--code.vue?vue&type=script&lang=js&"
export * from "./create--code.vue?vue&type=script&lang=js&"
import style0 from "./create--code.vue?vue&type=style&index=0&id=ad0b0e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0b0e72",
  null
  
)

export default component.exports